<script>
import RawData from "@/components/widgets/raw-data.vue";
import Details from "@/router/views/property/components/details";
import AssignmentHistory from "@/router/views/property/components/assignmenthistory";
import CurrentInventory from "@/router/views/property/components/inventory";
import InspectionHistory from "@/router/views/property/components/inspectionhistory";
import Attachments from "@/router/views/property/components/attachments";
export default {
    name: "PropertyTableCard",
    props: {
        propertyRow: {
            type: Object,
            required: true
        },
        isCheckCart: {
            type: Boolean,
            default: false
        },
        currentPage: {
            type: Number,
            default: 1
        },
        perPage: {
            type: Number,
            default: 10
        },
        assignmentHistoryEmployeeData: {
            type: Array,
            default: () => []
        },
        assignmentHistoryLocationData: {
            type: Array,
            default: () => []
        }
    },
    components: {
        RawData,
        Details,
        AssignmentHistory,
        CurrentInventory,
        InspectionHistory,
        Attachments
    },
    methods: {
        propertyNumberWidth(number) {
            if (number < 100) return "min-width: 35px";
            else if (number < 1000) return "min-width: 50px";
            else if (number < 10000) return "min-width: 60px";
            else return "min-width: 75px";
        },
        propertyStyle(row, cPage, pPage) {
            return this.propertyNumberWidth((cPage - 1) * pPage + (row.index + 1))
        },
        displayPropertyNumber(row) {
            if (row.propertyNumber && row.propertyNumber != "Not Indicated") {
                return `Property# ${row.propertyNumber}`;
            } else {
                return "Not Indicated";
            }
        },
        visibleString(row) {
            if (row.visible) {
                return "Hide";
            } else {
                return "Show";
            }
        },
        showDetails(row) {
            row.visible = !row.visible;
        },
    }
}
</script>
<template>
    <div class="position-relative ms-1">
        <RawData 
            :data="propertyRow.item" 
            :keyId="`search-showAll-${propertyRow.item.id}`"
            v-if="$store.state.decrypt.isAdmin()" 
        />
        <b-card-header header-tag="header" role="tab" class="border">
            <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center pe-5">
                    <div 
                        :style="propertyStyle(propertyRow, currentPage, perPage)" 
                        class="bg-success bg-gradient text-center me-2 py-1 position-relative"
                    >
                        <h3 class="mb-0 position-relative">{{ propertyRow.index + 1 }}</h3>
                    </div>
                    <div class="text-muted">
                        <h5 class="mb-0">{{ propertyRow.item.name }}</h5>
                        <div 
                            style="min-width: max-content">
                            <small class="d-flex align-items-center">
                                {{ displayPropertyNumber(propertyRow.item) }}
                                |
                                <a 
                                    href="javascript: void(0);" 
                                    class="text-success d-flex align-items-center ms-1"
                                    @click="showDetails(propertyRow.item)"
                                >
                                    {{ visibleString(propertyRow.item) }} Details
                                    <i 
                                        class="bx bx-chevron-right rotate font-size-14" 
                                        :class="{'rotate-90': propertyRow.item.visible}">
                                    </i>
                                </a>
                            </small>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center ms-5">
                    <div style="width: 200px" class="d-flex align-items-center">
                        <div class="text-muted">
                            <div>
                                <small class="d-flex align-items-center">Current Value:</small>
                            </div>
                            <h6 class="mb-0 text-warning">
                                {{ formatCurrency(propertyRow.item.currentValue) }}
                            </h6>
                        </div>
                    </div>
                    <div class="float-end d-flex align-items-center ms-3">
                        <i 
                            v-if="isCheckCart" 
                            title="Add to Cart"
                            class="mdi mdi-cart-outline font-size-18 text-info cursor-pointer me-1"
                            @click="$emit('add-to-cart')">
                        </i>
                        <i v-else 
                            title="Remove from Cart"
                            class="mdi mdi-cart-remove font-size-18 text-danger cursor-pointer me-1"
                            @click="$emit('remove-from-cart')">
                        </i>
                        <i 
                            class="bx bx-printer font-size-18 text-purple cursor-pointer ms-2" 
                            :id="`all-print-popover-${propertyRow.item.id}`"
                            tabindex="0">
                        </i>
                        <b-popover 
                            :target="`all-print-popover-${propertyRow.item.id}`" 
                            triggers="click blur" 
                            placement="leftbottom" 
                            variant="secondary"
                            custom-class="p-0"
                        >
                            <b-list-group class="w-100 fit">
                                <b-list-group-item 
                                    v-if="propertyRow.item.amount >= 50000" 
                                    button action
                                    class="d-flex align-items-center" 
                                    @click="$emit('print-par')"
                                >
                                    <i class="bx bx-printer text-purple font-size-18 me-1"></i>
                                    Print PAR
                                </b-list-group-item>
                                <b-list-group-item 
                                    v-else 
                                    button 
                                    action 
                                    class="d-flex align-items-center" 
                                    @click="$emit('print-ics')"
                                >
                                    <i class="bx bx-printer text-purple font-size-18 me-1"></i>
                                    Print ICS
                                </b-list-group-item>
                                <b-list-group-item 
                                    button action 
                                    class="d-flex align-items-center" 
                                    @click="$emit('print-sticker')"
                                >
                                    <i class="bx bx-printer text-purple font-size-18 me-1"></i>
                                    Print Sticker
                                </b-list-group-item>
                                <b-list-group-item 
                                    button action 
                                    class="d-flex align-items-center" 
                                    @click="$emit('print-property-card')"
                                >
                                    <i class="bx bx-printer text-purple font-size-18 me-1"></i>
                                    Print Property Card
                                </b-list-group-item>
                            </b-list-group>
                        </b-popover>
                        <i 
                            class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                            :id="`all-popover-${propertyRow.item.id}`" 
                            tabindex="0"
                        ></i>
                        <b-popover 
                            :target="`all-popover-${propertyRow.item.id}`" 
                            triggers="click blur" 
                            placement="leftbottom" 
                            variant="secondary"
                            custom-class="p-0"
                        >
                            <b-list-group class="w-100 fit">
                                <b-list-group-item button action class="d-flex align-items-center text-info"
                                    @click="$emit('update-item')"
                                >
                                    <i class="mdi mdi-update font-size-18 me-1"></i>
                                    Update Item
                                </b-list-group-item>
                            </b-list-group>
                        </b-popover>
                    </div>
                </div>
            </div>
        </b-card-header>
        <b-collapse :visible="propertyRow.item.visible" role="tabpanel">
            <div v-if="propertyRow.item.visible">
                <b-card 
                    no-body
                    class="shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0"
                >
                    <Details 
                        :key="`all-details-${propertyRow.item.id}`" 
                        :propertyRow="propertyRow.item"
                        :ref="`all-details-${propertyRow.item.id}`" 
                    ></Details>
                    <AssignmentHistory 
                        :key="`all-assignment-${propertyRow.item.id}`"
                        :propertyRow="propertyRow.item" 
                        :allowAssign="false" 
                        :allowEdit="true"
                        :allowTransfer="true" 
                        :employeeData="assignmentHistoryEmployeeData"
                        :locationData="assignmentHistoryLocationData"
                        :ref="`all-assignment-${propertyRow.item.id}`" 
                        @getEmployee="getEmployee($event)"
                        @getLocation="getLocation($event)"
                    />
                    <CurrentInventory 
                        :key="`all-inventory-${propertyRow.item.id}`"
                        :propertyRow="propertyRow.item" 
                        :ref="`all-inventory-${propertyRow.item.id}`"
                    />
                    <InspectionHistory 
                        :key="`all-inspection-${propertyRow.item.id}`"
                        :propertyRow="propertyRow.item" 
                        :ref="`all-inspection-${propertyRow.item.id}`"
                    />
                    <Attachments 
                        :key="`all-attachments-${propertyRow.item.id}`" 
                        :propertyRow="propertyRow.item" 
                        :ref="`all-attachments-${propertyRow.item.id}`"
                    />
                </b-card>
            </div>
        </b-collapse>
    </div>
</template>